import React from 'react';
import { motion } from 'framer-motion';
const reviews = [{
  id: 1,
  text: 'Bioquímica Metabólica era mi pesadilla. Con los esquemas de vías metabólicas por fin entendí cómo se conectaba todo. Aprobé con 8.',
  author: 'Valentina R.',
  details: 'La Plata'
}, {
  id: 2,
  text: 'Lo que más me sirvió fue el planner de cursada. Dejé de perder el rastro de qué parcial tenía cada semana.',
  author: 'Tomás F.',
  details: 'Rosario'
}, {
  id: 3,
  text: 'Química Orgánica nunca me había quedado tan clara como con los apuntes de este kit. Ojalá lo hubiera tenido en primer año.',
  author: 'Camila S.',
  details: 'Buenos Aires'
}];
export function Reviews() {
  return <section className="bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-219">
      <div className="max-w-2xl mx-auto" data-id="element-220">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl font-bold text-center text-brand-dark mb-8" data-id="element-221">
          Lo que dicen quienes ya lo tienen
        </motion.h2>

        <div className="space-y-4" data-id="element-222">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-light border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-223">
              <div className="text-brand-teal mb-2 text-sm tracking-widest" data-id="element-224">
                🌟🌟🌟🌟🌟
              </div>
              <p className="text-brand-dark italic mb-4 text-[15px]" data-id="element-225">
                "{review.text}"
              </p>
              <div className="text-sm font-medium" data-id="element-226">
                <span className="text-brand-dark font-bold" data-id="element-227">
                  {review.author}
                </span>
                <span className="text-gray-500" data-id="element-228"> · {review.details}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}